// Hoflich site content (sourced from Hoflich Profile PDF)
export const company = {
  name: "HOFLICH",
  tagline: "Develop Your Land Independently",
  subhead: "Maximize your property's value without relying on external developers",
  founded: 2014,
  founder: "Maheshwaram Vivek",
  city: "Hyderabad",
  phone: "+91 98854 94242",
  phoneAlt: "+91 40 2354 1493",
  email: "info@hoflich.in",
  website: "www.hoflich.in",
  whatsapp: "919885494242",
  address:
    "Plot No. 95/A, Road No. 44, Kavuri Hills, Jubilee Hills, Hyderabad, Telangana - 500033, India",
  mapEmbed:
    "https://maps.google.com/maps?q=Kavuri%20Hills%2C%20Jubilee%20Hills%2C%20Hyderabad&t=&z=15&ie=UTF8&iwloc=&output=embed",
};

export const stats = [
  { value: 12, suffix: "+", label: "Years of Expertise" },
  { value: 100, suffix: "+", label: "Happy Landowners" },
  { value: 5, suffix: "", label: "Pillars of Solutions" },
  { value: 360, suffix: "°", label: "Turnkey Support" },
];

export const services = [
  {
    code: "A",
    title: "Project Design",
    desc: "Comprehensive architectural and structural design solutions that balance aesthetics with regulatory compliance.",
  },
  {
    code: "B",
    title: "Project Approvals",
    desc: "End-to-end liaison across GHMC, HMDA, Fire, AAI, MoEF, and TGIIC to secure swift approvals.",
  },
  {
    code: "C",
    title: "Project Brochure for Sales & Strategic Planning",
    desc: "Transforming approved blueprints into compelling 3D renderings, pitch brochures, and sales collaterals.",
  },
  {
    code: "D",
    title: "Project Execution",
    desc: "Rigorous construction management, engineering quality checks, and site timeline oversight.",
  },
  {
    code: "E",
    title: "Project Funding",
    desc: "Connecting high-potential real estate developments with institutional construction loans and finance.",
  },
  {
    code: "F",
    title: "Project Handover",
    desc: "Final inspections, safety compliance clearance, and securing the Occupancy Certificate from the ULB.",
  },
];

export const industries = [
  {
    name: "Residential Complexes",
    img: "https://images.unsplash.com/photo-1775662904368-c3632b430103?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
  },
  {
    name: "Commercial Spaces",
    img: "https://images.unsplash.com/photo-1769556353286-b7f50da70d0c?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
  },
  {
    name: "Hospitals",
    img: "https://images.unsplash.com/photo-1764885415563-8b868745e9e2?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
  },
  {
    name: "IT Buildings",
    img: "https://images.unsplash.com/photo-1763560956421-b3e4083e9fc9?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80",
  },
  {
    name: "Educational Institutions",
    img: "https://images.unsplash.com/photo-1562774053-701939374585?auto=format&fit=crop&w=1400&q=80",
  },
  {
    name: "Gated Communities",
    img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=80",
  },
  {
    name: "Layouts & Land Parcels",
    img: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=1400&q=80",
  },
];

export const whyHoflich = [
  {
    title: "Fast-tracked Approvals",
    desc: "Decade-long expertise in ULB workflows helps accelerate sanction timelines.",
    icon: "Zap",
  },
  {
    title: "Government Expertise",
    desc: "Direct, compliant liaison across GHMC, HMDA, Fire, AAI, MoEF, TGIIC, and other regulatory bodies.",
    icon: "ShieldCheck",
  },
  {
    title: "Dedicated Project Team",
    desc: "A single point of accountability for every drawing, query and re-submission.",
    icon: "Users",
  },
  {
    title: "Technical Backbone",
    desc: "Pre-DCR & AutoDCR scrutiny, CAD compliance, due-diligence and risk identification.",
    icon: "Ruler",
  },
  {
    title: "Turnkey Delivery",
    desc: "From feasibility to OC — execution, quality control and smooth project handover.",
    icon: "PackageCheck",
  },
  {
    title: "Long-term Partnership",
    desc: "Trusted by 100+ builders and architects across Hyderabad for over a decade.",
    icon: "HeartHandshake",
  },
];

export const projects = [
  {
    title: "Premium Residences in Madhapur",
    sector: "Residential",
    location: "",
    img: "https://images.unsplash.com/photo-1598990891357-4ef3cd1f0f6d?crop=entropy&cs=srgb&fm=jpg&w=1800&q=80",
    video: "/videos/short1.mp4",
  },
  {
    title: "Premium Residences in Madhapur",
    sector: "Commercial",
    location: "",
    img: "https://images.unsplash.com/photo-1558573702-250d5cc26f70?crop=entropy&cs=srgb&fm=jpg&w=1800&q=80",
    video: "/videos/short2.mp4",
  },
  {
    title: "Apartments @ Central City",
    sector: "Healthcare",
    location: "",
    img: "https://images.unsplash.com/photo-1764885415563-8b868745e9e2?crop=entropy&cs=srgb&fm=jpg&w=1800&q=80",
    video: "/videos/short3.mp4",
  },
  {
    title: "Ultra Luxury Private Residence",
    sector: "IT / Tech Park",
    location: "",
    img: "https://images.unsplash.com/photo-1705682434049-9776abe248fe?crop=entropy&cs=srgb&fm=jpg&w=1800&q=80",
    video: "/videos/short4.mp4",
  },
  {
    title: "Outer Ring Road",
    sector: "Layout",
    location: "",
    img: "https://images.unsplash.com/photo-1770706240306-1010c2d321d7?crop=entropy&cs=srgb&fm=jpg&w=1800&q=80",
  },
];

export const timeline = [
  { step: "01", title: "Consultation", desc: "Brief, property feasibility & development sizing." },
  { step: "02", title: "Design", desc: "Custom architectural layouts & blueprint creations." },
  { step: "03", title: "Approvals", desc: "Fast-tracked government approvals & sanctions." },
  { step: "04", title: "Funding", desc: "Securing construction loan & project funding." },
  { step: "05", title: "Execution", desc: "High-quality, efficient site execution & construction." },
  { step: "06", title: "Marketing & Sales", desc: "Strategic sales support to maximize property value." },
];

export const clients = [
  "RMZ CORP",
  "LODHA",
  "GODREJ",
  "HIRANANDANI",
  "KIMS HOSPITALS",
  "GREENKO",
  "BIOLOGICAL E",
  "HITEX",
  "MINERVA",
  "DOYEN",
  "E11 HOMES",
  "ISTA HOMES",
  "VISTA SPACES",
  "SRAVANTHI",
  "PRATHIMA",
  "G PULLA REDDY",
  "KLR PROPERTIES",
  "L&W",
  "SIRI SAMPADA",
  "SRI GAYATHRI",
  "ARD ESTATES & PROJECTS",
];

export const testimonials = [
  {
    quote:
      "Hoflich helped us develop our Kavuri Hills land parcel independently. The architectural designs were stunning and they secured the project loan within 45 days.",
    name: "Landowner & Partner",
    company: "Residential Project, Hyderabad",
  },
  {
    quote:
      "Secured approvals, funding, and managed complete site execution on time. Building independently saved us over 20% in margins.",
    name: "Managing Director",
    company: "Commercial Space Owner",
  },
  {
    quote:
      "From architectural design to sales and marketing — they took complete accountability for our project. Truly a 360-degree partner.",
    name: "Co-Founder",
    company: "IT Office Park Developer",
  },
];
